import React from 'react';
import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
  PDFViewer,
} from '@react-pdf/renderer';
import logoJhimbo from '../images/logo-jhimbo-blanco.png';
import productoPrueba from '../images/imagen_card_prueba.jpeg';
import whatsapt from '../images/waza.png'
import ubicacion from '../images/maps_rojos.png';
import mundo from '../images/mundo.png';


const styles = StyleSheet.create({
  page: {
    padding: 0,
    fontFamily: 'Helvetica',
    fontSize: 9,
    backgroundColor:'#c0bebf'
  },
  header: {
    backgroundColor:'#3968fb',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems:'center',
    borderBottom: '1px solid #3968fb',
    width: '100%',
    paddingHorizontal: 10,
    paddingVertical: 5,
    marginBottom: 6
  },  
  logo: {
    width: 160,
    height: 50,
  },
  sectionLogo: {
    display:'flex',
    flexDirection:'column'
  },
  textLogo:{
    color:'#fff',
    fontSize:'10px',
    paddingLeft:'10px',
    position:'relative',
    bottom:'5px'
  },
  catalogoText: {
    fontSize: 18,
    fontWeight: '800',
    alignSelf: 'center',
    color:'#3968fb',
    backgroundColor:'#fff',
    padding:'10px',
    borderRadius:'15px',
    letterSpacing:'0.5px',
    position:'relative',
    right:'30px'
  },
  dateText: {
    color:'#fff',
    fontWeight:'bold',
    fontSize:'14px',
    paddingRight:'10px'
  },
  productoCard: {
    display:'flex',
    flexDirection:'column',
    border: '1px solid #ccc',
    margin: 5,
    padding: 5,
    width: '48%',
    height:'220px',
    borderRadius: 4,
    backgroundColor: '#fff',
    shadowColor: '#000',
    shadowOffset: { width: 1, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
    elevation: 3, 
  },
  
  productoCardLeft: {
    padding: 5,
    width: '60%',
    color: '#fff',
  },
  productoCardRight: {
    padding: 8,
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardArriba:{
    paddingTop:'5px',
    marginBottom:'3px',
    paddingBottom:'5px',
    borderBottom:'2px solid #3968fb'
  },
  cardAbajo:{
    display:'flex',
    flexDirection:'row'
  },
  productoImagen: {
    width: '100%',
    height: 160,
    objectFit: 'cover',
    marginBottom: 5,
  },
  productoTitulo: {
    fontSize: 9,
    fontWeight: 'bold',
    marginBottom: 2,
    textAlign: 'center',
    letterSpacing:'0.4px',
  },
  productoInfo: {
    fontSize: 8,
    marginBottom: 1,
  },
  productoPrecio: {
    marginTop: 5,
    fontSize: 9,
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor:'#3968fb',
    padding:'5px',
    borderRadius:'10px'
  },
  productosGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop:'5px'
  },
  detalleContenido:{
    display:'flex',
    flexDirection:'column',
    lineHeight:'0.7',
    backgroundColor:'#3968fb',
    color:'#fff', 
    padding:'5px',
    borderRadius:'10px'
  },
  detalleCodigo:{
    position:'relative',
    bottom:'3px',
    fontSize:'8px'
  },
  PrecioContent:{
    display:'flex',
    flexDirection:'row',
    justifyContent:'space-between',
    alignItems:'center'
  },
  PrecioTitle:{
    position:'relative',
    top:'3px'
  },
  footer: {
    backgroundColor:'#3968fb',
    padding: 0,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    borderTop: '1px solid #ccc',
    fontSize: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
    height:'45px',
    alignItems:'center',
    paddingRight:'10px',
    paddingLeft:'10px'
  },
  iconFooter:{
    width:'20px'
  },
  textFooter:{
    color:'#fff',
    fontSize:'10px',
    marginLeft:'3px'
  },
  contentDatosFooter:{
    display:'flex',
    flexDirection:'row',
    alignItems:'center'
  }
});

const CatalogoPDF = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Encabezado */}
      <View style={styles.header}>
        <View style={styles.sectionLogo}>
          <Image src={logoJhimbo} style={styles.logo} />
          <Text style={styles.textLogo}>Nit: 11310247</Text>
          <Text style={styles.textLogo}>Empresa: Importadora maquinarias Jhimbo</Text>
        </View>
        <Text style={styles.catalogoText}>CATÁLOGO</Text>
        <Text style={styles.dateText}>Fecha: 11-04-2025</Text>
      </View>

      {/* Productos */}
      <View style={styles.productosGrid}>
        {[...Array(6)].map((_, i) => (
        <View key={i} style={styles.productoCard}>
          <View style={styles.cardArriba}>
            <Text style={styles.productoTitulo}>COMPRESORA DE AIRE 60L SHTULTEC</Text>
          </View>

          <View style={styles.cardAbajo}>
            <View style={styles.productoCardLeft}>
              <Image src={productoPrueba} style={styles.productoImagen} />
            </View>
        
            <View style={styles.productoCardRight}>
              <View>
                <Text style={styles.detalleCodigo}>Código: ZF-250L</Text>
                <View style={styles.detalleContenido}>
                  <Text style={styles.productoInfo}>Código: ZF-250L</Text>
                  <Text style={styles.productoInfo}>Industria: Brasilera</Text>
                  <Text style={styles.productoInfo}>Uso: Industrial</Text>
                  <Text style={styles.productoInfo}>Potencia: 5hp</Text>
                  <Text style={styles.productoInfo}>Revolución: 5000pxm</Text>
                  <Text style={styles.productoInfo}>Demostración: en vivo</Text>
                  <Text style={styles.productoInfo}>Peso: 500kg</Text>
                  <Text style={styles.productoInfo}>Tarifa: 200</Text>
                  <Text style={styles.productoInfo}>Altura: 200m</Text>
                  <Text style={styles.productoInfo}>Demostración: en vivo</Text>
                  <Text style={styles.productoInfo}>Cobertura: Tigo</Text>
                  <Text style={styles.productoInfo}>Velocidad: 100km/h</Text>
                </View>
              </View>

              <View style={styles.PrecioContent}>
                <Text style={styles.PrecioTitle}>Precio:</Text>
                
                <Text style={styles.productoPrecio}>Bs. 3950</Text>
                
              </View>

            </View>
          </View>
          
          

        </View>
        
        ))}
      </View>

      {/* Pie de página */}
      <View style={styles.footer}>
        <View style={styles.contentDatosFooter}>
          <Image src={whatsapt} style={styles.iconFooter}/>
          <Text style={styles.textFooter}> 756-17338</Text>
        </View>
        <View style={styles.contentDatosFooter}>
          <Image src={ubicacion} style={styles.iconFooter}/>
          <Text style={styles.textFooter}> 2do y 3er anillo av. vg. de cotoca</Text>
        </View>
        <View style={styles.contentDatosFooter}>
          <Image src={mundo} style={styles.iconFooter}/>
          <Text style={styles.textFooter}> www.hosming.com/jhimbo</Text>
        </View>

      </View>
    </Page>
  </Document>
);

export const EjemploPdf = () => (
  <div style={{ width: '100%', height: '100vh' }}>
    <PDFViewer style={{ width: '100%', height: '100%' }}>
      <CatalogoPDF />
    </PDFViewer>
  </div>
);
